import UserPreference from './UserPreference';
import {IUserPreferencesRepository} from '../../@interfaces/services/Auth/IUserPreferencesRepository';
import {IUserPreferenceModel} from '../../@interfaces/models/User/IUserPreferenceModel';

export default class UserPreferencesRepository implements IUserPreferencesRepository {
    protected preferences: Record<string, UserPreference> = {};

    constructor(protected userId: number, protected rawPreferences: IUserPreferenceModel[]) {
        this.preferences = rawPreferences.reduce<Record<string, UserPreference>>((res, item) => {
            res[item.key] = this.createPreference(item.key);
            res[item.key].fill(item);

            return res;
        }, {});
    }

    has(key: string): boolean {
        return key in this.preferences;
    }

    get(key: string): UserPreference {
        if (!this.has(key)) {
            return this.preferences[key] = this.createPreference(key);
        }

        return this.preferences[key];
    }

    getValue(key: string): any | null {
        return this.get(key).getAttribute('value');
    }

    setValue(key: string, value: any) {
        return this.get(key).save({value});
    }

    protected createPreference(key: string, value: any | null = null): UserPreference {
        return new UserPreference(this, {id: null, user_id: this.userId, key, value});
    }
}
